<template>
  <div>
Test Test Test
  </div>
</template>

<script>
export default {
  name: "detail5",
};
</script>

<style scoped>

</style>
